export default __webpack_public_path__ + "static/media/Trisha Bhatia.cb6249a7.jpg";